export default {
    LibraryServices: {
        links: [
            {
                id: 'servicesforcommunity',
                title: 'Services for community',
                url: 'https://web.library.uq.edu.au/library-services/services-for-community',
            },
            {
                id: 'servicesforhdrs',
                title: 'Services for HDR students',
                url: 'https://web.library.uq.edu.au/library-services/services-higher-degree-by-research',
            },
            {
                id: 'servicesforhospital',
                title: 'Services for hospital staff',
                url: 'https://web.library.uq.edu.au/library-services/services-for-hospital-staff',
            },
            {
                id: 'requestliteraturesearch',
                title: 'Request literature search',
                url: 'https://web.library.uq.edu.au/library-services/services-hospital-staff/literature-request',
            },
            {
                id: 'servicesforprofessional',
                title: 'Services for professional staff',
                url: 'https://web.library.uq.edu.au/library-services/services-professional-staff',
            },
            {
                id: 'servicesforresearchers',
                title: 'Services for researchers',
                url: 'https://web.library.uq.edu.au/library-services/services-researchers',
            },
            {
                id: 'servicesforsecondary',
                title: 'Services for secondary schools',
                url: 'https://web.library.uq.edu.au/library-services/services-for-secondary-schools',
            },
            {
                id: 'servicesforstudents',
                title: 'Services for students',
                url: 'https://web.library.uq.edu.au/library-services/services-students',
            },
            {
                id: 'servicesforteaching',
                title: 'Services for teaching staff',
                url: 'https://web.library.uq.edu.au/library-services/services-teaching-staff',
            },
            {
                id: 'servicesforalumni',
                title: 'Services for UQ alumni',
                url: 'https://web.library.uq.edu.au/library-services/services-uq-alumni',
            },
            {
                id: 'servicesforexternal',
                title: 'Services for external and remote students',
                url:
                    'https://web.library.uq.edu.au/borrowing-requesting/how-borrow/borrowing-external-and-remote-students',
            },
            {
                id: 'ithelp',
                title: 'IT Help',
                url: 'https://web.library.uq.edu.au/library-services/it',
            },
            {
                id: 'digitalessentials',
                title: 'Improve your digital skills',
                url: 'https://web.library.uq.edu.au/research-tools-techniques/digital-essentials',
            },
        ],
    },
};
